import React from 'react';
import { SITE_TITLE } from 'apps/sigma2-ui/src/constants/site-meta';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { IconArrowLeft24pxSvg } from 'apps/sigma2-ui/src/components/svg/IconArrowLeft24px';
import { Sigma2LogoNoFillSvg } from 'apps/sigma2-ui/src/components/svg/Sigma2LogoNoFill';
import AuthLayoutBackground from './AuthLayoutBackground';
import { RoutableLink } from 'apps/sigma2-ui/src/components/ui/RoutableLink';

export const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  const language = useLanguage();

  return (
    <main className="w-screen h-screen bg-blue-1000 overflow-hidden px-6">
      <div className="max-w-content min-w-content w-full mx-auto grid grid-cols-12 grid-rows-3 gap-8 h-full items-start">
        <RoutableLink
          to="/"
          title={language.navBackToHome()}
          className="col-start-1 row-start-1 col-span-2 relative z-standout w-12 h-12 bg-white top-20 rounded-full justify-center align-middle flex text-primary focus:outline-none focus-visible:ring-1 focus-visible:ring-blue-300 transition focus-visible:ring-offset-2 focus-visible:ring-offset-blue-1000 hover:bg-blue-100 active:bg-blue-300 items-center"
        >
          <IconArrowLeft24pxSvg svg={{ className: 'w-6' }} />
          <span className="sr-only">{language.navBackToHome()}</span>
        </RoutableLink>
        <div className="col-start-2 col-span-4 row-start-2 pt-6">
          <div className="relative text-left text-gray-100 ">
            <div
              className="absolute transform -translate-x-2/4 -translate-y-1/2"
              style={{ top: '3rem', left: '14rem', width: 1824 }}
            >
              <AuthLayoutBackground />
            </div>
            <div className="relative">
              <Sigma2LogoNoFillSvg svg={{ className: 'w-28' }} />
              <p className=" text-4xl mt-4 font-bold whitespace-nowrap">
                {SITE_TITLE}
              </p>
            </div>
          </div>
        </div>
        <div className="relative col-start-8 col-span-4 row-start-2 text-gray-100">
          {children}
        </div>
      </div>
    </main>
  );
};
